<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="toc">contents</h1>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740790683_epub_ack_r1.htm">Acknowledgments</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_for_r1.htm">Foreword</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_int_r1.htm">Introduction</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_c01_r1.htm">Cocktails and Wine</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_c02_r1.htm">Cold Tapas</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_c03_r1.htm">Hot Tapas</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_c04_r1.htm">Main Courses and Party Dishes</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_c05_r1.htm">Desserts</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_bm1_r1.htm">Sources</a></p>
<p class="extract1"><a class="hlink" href="#/OEBPS/9780740790683_epub_bm2_r1.htm">Metric Conversions and Equivalents</a></p>
<p class="center"><img alt="" src="OEBPS/images/viii-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740790683_epub_toc_r1.vue?52c1c2e1